// Parses input of the currency, separating amount and decimal to process separately
import {
  guessFloatPrecision, isValidFloat, isValidInteger, removeLeadingZeros,
} from './Utils';

type NumberParam =  number | string;

export default class CurrencyNumber {
  protected amount = 0;

  protected decimal = 0;

  constructor(number: NumberParam) {
    this.setNumber(number);
  }

  getDecimalPrecision(): number {
    return this.decimal;
  }

  setNumber(number: NumberParam): void {
    this.decimal = 0;
    if (typeof number === 'number') {
      this.setupString(number.toString());
    } else {
      this.setupString(number);
    }
  }

  toFixed(precision = 0): string {
    let string = this.toString();
    const diff = precision - this.getDecimalPrecision();
    if (diff > 0) {
      // diff bigger than zero pads zeros at the end
      if (!string.includes('.')) {
        // if it is an integer, add a dot
        string += '.';
      }
      return string.padEnd(string.length + diff, '0');
    }
    if (diff < 0) {
      return string.slice(0, diff);
    }
    return string;
  }

  toString(): string {
    let string = this.amount.toString();
    if (this.decimal) {
      let isNegative = false;
      if (string.charAt(0) === '-') {
        string = string.substring(1);
        isNegative = true;
      }
      string = string.padStart(string.length + this.decimal, '0');
      string = `${string.slice(0, -this.decimal)}.${string.slice(-this.decimal)}`;
      string = removeLeadingZeros(string);

      return (isNegative ? '-' : '') + string;
    }
    return string;
  }

  setupString(number: string): void {
    number = removeLeadingZeros(number);

    if (isValidInteger(number)) {
      this.amount = Number(number);
    } else if (isValidFloat(number)) {
      this.decimal = guessFloatPrecision(number);
      this.amount = Number(number.replace('.', ''));
    } else {
      throw new Error(`BigNumber has received and invalid format for the constructor: ${number}`);
    }
  }
}
